import { createContext, useContext } from 'react';

type CampaignsCreationContextValue = {
  openNew: () => void;
};

const CampaignsCreationContext =
  createContext<CampaignsCreationContextValue | null>(null);

export const CampaignsCreationProvider = CampaignsCreationContext.Provider;

export const useCampaignsCreation =
  (): CampaignsCreationContextValue | null =>
    useContext(CampaignsCreationContext);
